import { render, staticRenderFns } from "./EditPropertyInCommercial.vue?vue&type=template&id=1326e9b9&"
import script from "./EditPropertyInCommercial.vue?vue&type=script&lang=js&"
export * from "./EditPropertyInCommercial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports